import React, { useCallback, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import Slide from "@mui/material/Slide";
import ContactModal from "./ContactModal";
import ArrowForward from "@mui/icons-material/ArrowForward";

const pages = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "About us",
    path: "/about",
  },
  {
    title: "Services",
    data: [
      {
        title: "SaaS Services",
        path: "saas-service",
      },
      {
        title: "Business Intelligence",
        path: "business-intelligence",
      },
      {
        title: "Web & Mobile App Development",
        path: "app-development",
      },
    ],
  },
  {
    title: "How we work?",
    path: "/how-we-work",
  },
];

const WebView = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClick = useCallback(
    (item) => {
      window.scrollTo(0, 0);
      navigate(`/services/${item}`);
      setAnchorEl(null);
    },
    [navigate]
  );

  // useEffect(() => {
  //   // Scroll to top when the route changes

  // }, [pathname]);

  const Web_screen_header = useMemo(() => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: {
            lg: 2,
            xl: 4,
          },
        }}
      >
        {pages.map((item) => {
          if (item.title === "Services") {
            return (
              <>
                <Button
                  key={item.title}
                  aria-controls={open ? "grouped-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={(e) => handleClick(e)}
                  sx={{ color: "#fff", textTransform: "none" }}
                >
                  <Typography
                    sx={{
                      fontFamily: "'Montserrat', sans-serif",
                      color: "#fff",
                      textAlign: "center",
                      textTransform: "none",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    Services <ArrowDropDownIcon />
                  </Typography>
                </Button>
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={() => setAnchorEl(null)}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                  sx={{
                    "& .MuiPaper-root": {
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.primary.white,
                      border: `1px solid #ffffffc4`,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      alignContent: "space-between",
                      p: 0,
                    },
                    "& .MuiList-root": {
                      padding: 0,
                    },
                  }}
                >
                  {item.data.map((child) => {
                    return (
                      <MenuItem
                        key={child.title}
                        onClick={() => handleMenuClick(child.path)}
                        sx={{
                          color: theme.palette.primary.white,
                          // opacity: "90%",
                          cursor: "pointer",
                          position: "relative",
                          "&:hover": {
                            opacity: 1,
                          },
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            left: "50%",
                            bottom: 0,
                            width: "0%",
                            height: "1px",
                            backgroundColor: theme.palette.primary.white,
                            transition:
                              "width 0.3s ease-in-out, left 0.3s ease-in-out",
                          },
                          "&:hover::after": {
                            width: "100%",
                            left: "0%",
                          },
                        }}
                      >
                        {child.title}
                      </MenuItem>
                    );
                  })}
                </Menu>
              </>
            );
          }
          return (
            <Button
              key={item.title}
              onClick={() => navigate(item.path)}
              sx={{
                textTransform: "none",
              }}
            >
              <Typography
                // variant="h5"
                sx={{
                  color: theme.palette.primary.white,
                  // opacity: "90%",
                  cursor: "pointer",
                  position: "relative",
                  "&:hover": {
                    opacity: 1,
                  },
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    left: "50%",
                    bottom: 0,
                    width: "0%",
                    height: "1px",
                    backgroundColor: theme.palette.primary.white,
                    transition: "width 0.3s ease-in-out, left 0.3s ease-in-out",
                  },
                  "&:hover::after": {
                    width: "100%",
                    left: "0%",
                  },
                }}
              >
                {item.title}
              </Typography>
            </Button>
          );
        })}
      </Box>
    );
  }, [
    handleMenuClick,
    anchorEl,
    navigate,
    open,
    theme.palette.primary.main,
    theme.palette.primary.white,
  ]);

  const Web_screen_buttons = useMemo(() => {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          gap: 4,
        }}
      >
        <Button
          onClick={() => setOpenModal(true)}
          sx={{
            textTransform: "none",
            border: `1px solid ${theme.palette.primary.gray}`,
            display: "flex",
            alignItems: "center",
            color: "rgba(255,255,255,0.95)",
            borderColor: "rgba(255,255,255,0.4)",
            p: 1.5,
            borderRadius: 1,
            "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
          }}
          variant="outlined"
        >
          <Typography
            variant="h5"
            sx={{
              lineHeight: 1,
            }}
          >
            Contact Us
          </Typography>
        </Button>
        <Button
          sx={{
            textTransform: "none",
            border: `1px solid ${theme.palette.primary.gray}`,
            display: "flex",
            alignItems: "center",
            color: "rgba(255,255,255,0.95)",
            borderColor: "rgba(255,255,255,0.4)",
            p: 1,
            borderRadius: 1,
            "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
          }}
          type="submit"
          variant="outlined"
          endIcon={<LanguageIcon />}
        >
          <Typography
            sx={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "14px",
              textTransform: "Uppercase",
            }}
          >
            En
          </Typography>
        </Button>
      </Box>
    );
  }, [theme.palette.primary.gray]);

  return (
    <>
      <Box
        sx={{
          position: "relative",
          top: 0,
          zIndex: 1200,
          backgroundColor: "transparent",
          boxShadow: "4px 10px 50px 20px rgba(0, 0, 0, 0.43)",
          minHeight: "7.5vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "90%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <img
              src="/header_logo.png"
              alt="Header Logo"
              style={{ height: 46, marginRight: "1rem" }}
            />
            <Typography
              variant="h4"
              sx={{ fontSize: { xs: "1rem", md: "1.5rem" } }}
            >
              InfinityHyperCloud
            </Typography>
          </Box>
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              width: "60%",
            }}
          >
            {Web_screen_header}
            {Web_screen_buttons}
          </Stack>
          <ContactModal openModal={openModal} setOpenModal={setOpenModal} />
        </Box>
      </Box>
    </>
  );
};

const MobileView = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const theme = useTheme();
  const navigate = useNavigate();

  const handleOpenMenu = useCallback(() => {
    setIsMobileMenuOpen((prev) => !prev);
  }, []);

  const handleServiceMenuClick = useCallback(
    (item) => {
      window.scrollTo(0, 0);
      navigate(`/services/${item}`);
      setIsMobileMenuOpen(false);
    },
    [navigate]
  );

  const handleMenuClick = useCallback(
    (item) => {
      navigate(item);
      setIsMobileMenuOpen(false);
    },
    [navigate]
  );

  const MobileMenu = useMemo(() => {
    return (
      <Slide direction="left" in={isMobileMenuOpen} mountOnEnter unmountOnExit>
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100vw",
            height: "92.5vh",
            backgroundColor: theme.palette.primary.main,
            display: "flex",
            flexDirection: "column",
            justifyContent: " flex-start",
            alignItems: "flex-start",
            zIndex: 1300,
          }}
        >
          <Box
            sx={{
              height: "50vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              ml: 2,
              mt: 10,
              width: "80%",
            }}
          >
            <Box>
              {pages
                .filter((item) => item.title !== "Services")
                .map((item, index) => {
                  return (
                    <Button
                      key={index}
                      sx={{
                        textTransform: "none",
                        display: "flex",
                        justifyContent: "flex-start",
                        textAlign: "left",
                        gap: 1,
                        color: "rgba(255,255,255,0.95)",
                        borderRadius: 1,
                        "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
                      }}
                      type="submit"
                      variant="outlined"
                      endIcon={<ArrowForward />}
                      onClick={() => {
                        if (item.path) {
                          handleMenuClick(item.path);
                        }
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "'Montserrat', sans-serif",
                          fontSize: "16px",
                        }}
                      >
                        {item.title}
                      </Typography>
                    </Button>
                  );
                })}
            </Box>

            {/* SERVICES */}

            <Box>
              {(() => {
                const services = pages.find((p) => p.title === "Services");
                if (!services || !Array.isArray(services.data)) return null;
                return (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Button
                      sx={{
                        textTransform: "none",
                        display: "flex",
                        justifyContent: "flex-start",
                        textAlign: "left",
                        color: "rgba(255,255,255,0.95)",
                        px: 2,
                        borderRadius: 1,
                        "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "'Montserrat', sans-serif",
                          fontSize: "16px",
                        }}
                      >
                        Services
                      </Typography>
                    </Button>

                    {services.data.map((child, childIndex) => {
                      return (
                        <Button
                          key={childIndex}
                          onClick={() => handleServiceMenuClick(child.path)}
                          sx={{
                            textTransform: "none",
                            display: "flex",
                            justifyContent: "flex-start",
                            gap: 1,
                            color: "rgba(255,255,255,0.95)",
                            minWidth: 332,
                            borderRadius: 1,
                            textAlign: "left",
                            "&:hover": {
                              borderColor: "rgba(255,255,255,0.75)",
                            },
                          }}
                          type="submit"
                          variant="outlined"
                        >
                          <Typography
                            sx={{
                              fontFamily: "'Montserrat', sans-serif",
                              fontSize: "16px",
                            }}
                          >
                            {child.title}
                          </Typography>
                          <ArrowForward
                            alignSelf="flex-start"
                            sx={{
                              fontSize: 16,
                            }}
                          />
                        </Button>
                      );
                    })}
                  </Box>
                );
              })()}
            </Box>
            <Box
              sx={{
                gap: 2,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Button
                href="https://calendar.app.google/yyQ665soutqZzj1H9"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  textTransform: "none",
                  border: `1px solid ${theme.palette.primary.gray}`,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "rgba(255,255,255,0.95)",
                  borderColor: "rgba(255,255,255,0.4)",
                  px: 3,
                  py: 1.25,
                  ml: 3,
                  maxWidth: 200,
                  borderRadius: 1,
                  "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
                }}
                type="submit"
                variant="outlined"
                endIcon={<ArrowForward />}
              >
                <Typography
                  sx={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: "14px",
                  }}
                >
                  Schedule a Call
                </Typography>
              </Button>
              <Button
                sx={{
                  textTransform: "none",
                  border: `1px solid ${theme.palette.primary.gray}`,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "rgba(255,255,255,0.95)",
                  borderColor: "rgba(255,255,255,0.4)",
                  px: 3,
                  py: 1.25,
                  ml: 3,
                  maxWidth: 200,
                  borderRadius: 1,
                  "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
                }}
                variant="outlined"
              >
                <LanguageIcon sx={{ color: "#fff" }} />
                <Typography
                  sx={{
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: "14px",
                    textTransform: "Uppercase",
                  }}
                >
                  En
                </Typography>
              </Button>
            </Box>
          </Box>
        </Box>
      </Slide>
    );
  }, [isMobileMenuOpen, theme, handleServiceMenuClick, handleMenuClick]);

  const Burger_menu = useMemo(() => {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
        }}
      >
        {isMobileMenuOpen ? (
          <Box
            sx={{
              borderRadius: "50%",
              border: "1px solid rgba(255, 255, 255, 0.7)",
              p: 0.3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CloseIcon
              onClick={handleOpenMenu}
              sx={{ fontSize: 25, color: "#fff" }}
            />
          </Box>
        ) : (
          <MenuIcon
            onClick={handleOpenMenu}
            sx={{ fontSize: 30, color: "#fff" }}
          />
        )}
      </Box>
    );
  }, [handleOpenMenu, isMobileMenuOpen]);

  return (
    <>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 1200,
          backgroundColor: theme.palette.primary.main,
          boxShadow: "4px 10px 50px 20px rgba(0, 0, 0, 0.43)",
          minHeight: "7.5vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "90%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", ml: 2 }}>
            <img
              src="/header_logo.png"
              alt="Header Logo"
              style={{ height: 46, marginRight: "1rem" }}
            />
          </Box>
          {Burger_menu}
          {MobileMenu}
        </Box>
      </Box>
    </>
  );
};

const Header = () => {
  const theme = useTheme();

  const isLapTopScreen = useMediaQuery(theme.breakpoints.up("laptop"));

  return isLapTopScreen ? <WebView /> : <MobileView />;
};

export default Header;
